import React from "react";
import axios from 'axios';
import { Link } from "react-router-dom";

import "./listaUsuarios.css";
import verificandoToken from '../../../FuncoesGerais/VerificarToken';
import { ensureProtocol } from '../../../config/backend';

function ListaUsuarios(props) {

    const deleteUsuario = async (usuSeq) => {

        let confirmacao = window.confirm("Você realmente deseja excluir o usuário " + usuSeq + "?");

        verificandoToken();

        const token = localStorage.getItem('token');

        if (confirmacao) {
            try {

                await axios.delete(ensureProtocol(localStorage.getItem("ipBackend2")) + "/usuarios", {
                    headers: {
                        Authorization: `${token}`
                    },
                    data: {
                        usuSeq
                    }
                });

                alert("Usuario " + usuSeq + " deletado com sucesso!");

                window.location.reload();

            } catch (error) {
                console.error('Erro:', error);
            }
        }
    };

    return (
        <div className="lista-wrapper">
            <table className="table table-modern align-middle">
                <thead>
                    <tr>
                        <th scope="col">Sequência</th>
                        <th scope="col">Nome</th>
                        <th scope="col">Empresa / CNPJ</th>
                        <th scope="col">Login</th>
                        <th scope="col">Situação</th>
                        <th scope="col">Eqp.</th>
                        <th scope="col" width="80"></th>
                    </tr>
                </thead>
                <tbody>
                    {(props.arrayUsuarios || []).map((usuario) => {
                        const ehProprioUsuario = props.usuarioLogadoId != null && Number(usuario.usuSeq) === Number(props.usuarioLogadoId);
                        const podeEditarProprio = ehProprioUsuario && props.allowEditOwnUser;
                        const linhaClicavel = props.onEdit && (!ehProprioUsuario || podeEditarProprio);
                        return (
                        <tr
                            key={usuario.usuSeq}
                            className={linhaClicavel ? 'table-row-clickable' : ''}
                            onClick={() => linhaClicavel && props.onEdit(usuario.usuSeq)}
                        >
                            <td>
                                {props.onEdit ? (
                                    ehProprioUsuario && !props.allowEditOwnUser ? (
                                        <span className="text-muted" title="Não é permitido editar seu próprio cadastro">{usuario.usuSeq}</span>
                                    ) : (
                                        <button type="button" className="btn btn-link p-0" onClick={(e) => { e.stopPropagation(); props.onEdit(usuario.usuSeq); }} title={ehProprioUsuario ? 'Editar meu cadastro' : ''}>{usuario.usuSeq}</button>
                                    )
                                ) : (
                                    <Link to={{ pathname: '/listaUsuario', state: { editId: usuario.usuSeq } }}>{usuario.usuSeq}</Link>
                                )}
                            </td>
                            <td>{usuario.usrNomCpl}</td>
                            <td>{usuario.empresaCliente || '—'}</td>
                            <td>{usuario.usrLgn}</td>
                            <td>
                                <span className={`badge-pill ${usuario.usrSit === 'A' ? 'badge-ativo' : 'badge-inativo'}`}>
                                    {usuario.usrSit === 'A' ? 'Ativo' : 'Inativo'}
                                </span>
                            </td>
                            <td onClick={(e) => e.stopPropagation()}><Link to={'/hardwaresUsuario/' + usuario.usuSeq} className="text-primary"><i className="fas fa-gears" /></Link></td>
                            <td onClick={(e) => e.stopPropagation()}>
                                {ehProprioUsuario ? (
                                    <button type="button" className="btn btn-secondary btn-sm" disabled title="Não é permitido excluir a si mesmo"><i className="fas fa-trash" /></button>
                                ) : (
                                    <button className="btn btn-danger btn-sm" onClick={() => deleteUsuario(usuario.usuSeq)} type="button" title="Excluir"><i className="fas fa-trash" /></button>
                                )}
                            </td>
                        </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

export default ListaUsuarios;
